import React, { useState } from "react";
import { useAuth } from "../../auth/AuthContext";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    console.log("LogoutPage handleLogout");
    setIsLoggingOut(true); // Disable button during logout
    try {
      localStorage.removeItem("previousPath"); // Clear previous path for navigation
      console.log("LogoutPage handleLogout");
      await logout(); // Ensure `logout` returns a Promise

      navigate("/"); // Redirect to the home page
    } catch (error) {
      console.error("Logout failed:", error);
      alert("Logout failed. Please try again."); // Show user-friendly error message
    } finally {
      setIsLoggingOut(false); // Re-enable button after logout attempt
    }
  };

  return (
    <button
      onClick={handleLogout}
      className={`btn btn-danger ${isLoggingOut ? "disabled" : ""}`}
      disabled={isLoggingOut} // Disable button while logging out
    >
      {isLoggingOut ? (
        <span>
          <span
            className="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          ></span>
          Logging out...
        </span>
      ) : (
        "Logout"
      )}
    </button>
  );
};

export default Logout;
